module.exports = __webpack_public_path__ + "img/educacao2.724ae9cb.svg";